import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { formatRupiah } from "@/lib/constants";
import { Input } from "@/components/ui/input";

export default function WaitingSpk() {
  const [rows, setRows] = useState(null);
  const [q, setQ] = useState("");
  useEffect(() => { api.get("/waiting-spk").then((r) => setRows(r.data)).catch(() => setRows([])); }, []);
  const list = (rows || []).filter((r) => !q || `${r.license_plate} ${r.customer_name} ${r.insurance_company}`.toUpperCase().includes(q.toUpperCase()));
  return (
    <div data-testid="waiting-spk-page">
      <h1 className="font-heading text-2xl font-bold text-[#111827]">WAITING SPK</h1>
      <p className="mt-1 text-xs text-gray-500">Claim terdaftar, menunggu SPK Fix dari asuransi (rincian diproses di Merimen/asuransi). Buka claim untuk UPLOAD SPK FIX.</p>
      <Input data-testid="waiting-spk-search" value={q} onChange={(e) => setQ(e.target.value)} placeholder="Cari nopol / nama / asuransi" className="mt-3 max-w-sm" />
      <div className="mt-3 overflow-x-auto rounded-lg border border-gray-200 bg-white">
        <table className="w-full min-w-[760px] text-left text-sm">
          <thead className="bg-gray-50 text-xs text-gray-500"><tr>{["Nopol", "Pelanggan", "Merek", "Asuransi", "Estimasi", "Registrasi", "SA", "Umur"].map((h) => <th key={h} className="px-3 py-2">{h}</th>)}</tr></thead>
          <tbody>{list.map((r) => (
            <tr key={r.id} data-testid={`waiting-spk-row-${r.id}`} className="border-t border-gray-100">
              <td className="px-3 py-2 font-bold"><Link to={`/claims/${r.id}`} className="text-orange-600 hover:underline">{r.license_plate}</Link></td>
              <td className="px-3 py-2">{r.customer_name}<div className="text-[11px] text-gray-500">{r.customer_phone}</div></td>
              <td className="px-3 py-2">{r.vehicle_brand}</td><td className="px-3 py-2">{r.insurance_company}</td>
              <td className="px-3 py-2">{r.estimate_total ? formatRupiah(r.estimate_total) : "-"}</td>
              <td className="px-3 py-2 text-xs">{String(r.registered_at || "").slice(0, 16).replace("T", " ")}</td>
              <td className="px-3 py-2 text-xs">{r.registered_by || "-"}</td>
              <td className={`px-3 py-2 text-xs font-semibold ${r.aging_days > 7 ? "text-red-600" : "text-gray-700"}`}>{r.aging_days} hari</td>
            </tr>
          ))}</tbody>
        </table>
        {rows && !list.length && <p data-testid="waiting-spk-empty" className="p-4 text-sm text-gray-500">Tidak ada claim menunggu SPK.</p>}
        {!rows && <p className="p-4 text-sm text-gray-500">Memuat…</p>}
      </div>
    </div>
  );
}
